import useMediaQuery from "@mui/material/useMediaQuery";

import { useTheme } from "@/components/ui-v2";

export const useIsMobile = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return isMobile;
};
